module.exports = __webpack_public_path__ + "static/media/goauto-biale.df4d54ed.png";